import { defineQuery } from "@rocicorp/zero";
import { z } from "zod";
import type {} from "../zero-context";
import { zql } from "../schema";
import { workspaceAdminSurfaceGuard } from "./access-filters";

export const workspaceSkillsQueries = {
  // Skills are workspace management (prompts + tool bindings) — admin-only in a
  // PUBLIC workspace, full members in a PRIVATE one. See workspaceAdminSurfaceGuard.
  byWorkspace: defineQuery(z.string(), ({ args: workspaceId, ctx: { sub } }) =>
    zql.workspace_skills
      .where("workspace_id", workspaceId)
      .where("enabled", true)
      .whereExists("workspace", workspaceAdminSurfaceGuard(sub)),
  ),
};
